















































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import CustomIntegration from './custom-integrations/custom-integrations.vue';
import ImportApi from '@/services/rest/bemob/import';
import DomainsApi from '@/services/rest/bemob/domains';
import api from '@/services/utils/base';
import { AclMixin } from '@/components/acl/acl-mixin';
import { mixins } from 'vue-class-component';
import _ from 'lodash';

@Component({
  components: {
    CustomIntegration
  }
})
export default class Integrations extends mixins(AclMixin) {
    importResults: boolean = false;
    domainsApi: DomainsApi = new DomainsApi();
    form: any = this.getDefaultForm();
    clickBank: string = '';
    clickBankInstant: string = '';
    importing: boolean = false;

    selected: any = {};

    getDefaultForm() {
      return {
        login: '',
        password: '',
      };
    } 

    @Watch('tab')
    appendRelatedToAllSelected() {
        if(this.tab !== 6)
            return;

        _.forOwn(this.selected, type => {
           _.forEach(type || [], item => {
               this.appendRelated(item);
           });
        });
    }

    items: any = {};

    tabs: string[] = [
      'campaigns',
      'trafficSources',
      'flows',
      'landings',
      'offers',
      'affiliateNetworks'
    ];

    tab: any = 0;

    async mounted() {
        this.$store.commit('loading', true);
  
        if(!this.$store.state.cache.trackingDomains.isUploaded){
          await this.domainsApi.trackingDomainsPopulateStoreCache()
        }
        const notCustomTrackingDomains = this.$store.state.cache.trackingDomains.data.filter(item=>!item.custom)

      this.clickBank = this.$store.state.user.subdomain.toUpperCase();
        this.clickBankInstant =
          `${notCustomTrackingDomains[0].httpsAvailable ? 'https' : 'http'}://${notCustomTrackingDomains[0].domain}/clickbank-ins`;

        this.$store.commit('loading', false)
    }

    appendRelated(item: any){
        if (item.uses && item.uses.flow){
            (this.items['flows'] || [] ).map((flow: any)=>{
                if (flow.id === item.uses.flow)
                {
                    this.selected['flows'] = (this.selected['flows'] || []).filter((e:any)=>e.id!==flow.id);
                    flow.selected = true;
                    flow.$depends = item.name;
                    this.selected['flows'].push(flow);
                    this.appendRelated(flow);
                }
            })
        }
        if (item.trafficSourceId){
            (this.items['trafficSources'] || [] ).map((ts: any)=>{
                if (ts.id === item.trafficSourceId)
                {
                    this.selected['trafficSources'] = (this.selected['trafficSources'] || []).filter((e:any)=>e.id!==ts.id);
                    ts.selected = true;
                    ts.$depends = item.name;
                    this.selected['trafficSources'].push(ts);
                    this.appendRelated(ts);
                }
            })
        }

        if (item.uses && item.uses.offers){
            (this.items['offers'] || [] ).map((offer: any)=>{
                if (item.uses.offers.indexOf(offer.id) !== -1)
                {
                    this.selected['offers'] = (this.selected['offers'] || []).filter((e:any)=>e.id!==offer.id);
                    offer.selected = true;
                    offer.$depends = item.name;
                    this.selected['offers'].push(offer);
                    this.appendRelated(offer);
                }
            })
        }

        if (item.uses && item.uses.landings){
            (this.items['landings'] || [] ).map((land: any)=>{
                if (item.uses.landings.indexOf(land.id) !== -1)
                {
                    this.selected['landings'] = (this.selected['landings'] || []).filter((e:any)=>e.id!==land.id);
                    land.selected = true;
                    land.$depends = item.name;
                    this.selected['landings'].push(land);
                    this.appendRelated(land);
                }
            })
        }

        if (item.uses && item.uses.affiliateNetwork){
            (this.items['affiliateNetworks'] || [] ).map((an: any)=>{
                if (an.id === item.uses.affiliateNetwork)
                {
                    this.selected['affiliateNetworks'] = (this.selected['affiliateNetworks'] || []).filter((e:any)=>e.id!==an.id);
                    an.selected = true;
                    an.$depends = item.name;
                    this.selected['affiliateNetworks'].push(an);
                    this.appendRelated(an);
                }
            })
        }
    }

    importSettings() {
        this.$store.commit('loading', true);
        new ImportApi()
          .postSettings('voluum', this.form)
          .then((data: any)=>{
            this.importResults = true;
            this.selected = {};
            this.items = data;
            this.tab = 0;
            
            this.form = this.getDefaultForm();
          })
          .catch((e)=>{
            this.form.password = '';
            this.bus.emit('toast-error', this.t('Email / Password is invalid'));
          })
          .finally(() => {
            this.$store.commit('loading', false);
          });
    }

    select(type: string, item: any) {
       this.selected[type] = this.selected[type] || [];
       let found = this.selected[type].filter((e: any)=> e.id === item.id)[0];
       if (found) {
           this.selected[type] = this.selected[type].filter((e: any)=> e.id !== item.id);
           item.selected = false;
       }
       else {
           item.selected = true;
           // this.appendRelated(item);
           this.selected[type].push(item);
       }
       this.$forceUpdate();
    }

    selectAll(type: any) {
        if (this.selected[type] && this.items[type].length == this.selected[type].length)
        {
            this.selected[type] = [];
            this.items[type].map((e: any)=>{
                e.selected = false;
            });
            this.$forceUpdate();
            return;
        }
        this.selected[type] = this.items[type];
        this.items[type].map((e: any)=>{
            // this.appendRelated(e);
            e.selected = true;
            this.$forceUpdate();
        });
        this.$forceUpdate();
    }

    get length(){
        // хак, не убирать
        if(this.tab < 0)
            return 0;

        return this.tabs.map((e)=>{
            let data: any[] = this.selected[e];
            return data
                ? data.length
                : 0;
        }).reduce((a, b) => a + b, 0);
    }

    nextTab() {
        if (this.tab <= 5)
            this.tab +=1
    }

    async doImport() {
        this.importing = true;

        try {

          let replaceIds: any = {};
          let tasks: any[] = [];
          let selection = this.selected['affiliateNetworks'];
          if (selection && selection.length) {
            tasks = selection.map((data: any) => api
              .post('affiliate-networks', data)
              .then((created: any) => {
                replaceIds[data.id] = created.data.payload.id;
              })
            );
            await Promise.all(tasks);
          }

          selection = this.selected['landings'];
          if (selection && selection.length) {
            tasks = selection.map((data: any) => api
              .post('landings', data)
              .then((created: any) => {
                replaceIds[data.id] = created.data.payload.id;
              })
            );
            await Promise.all(tasks);
          }

          selection = this.selected['offers'];
          if (selection && selection.length) {
            tasks = selection.map((data: any) => {

              let create = JSON.stringify(data);
              _.forOwn(replaceIds, (to, from) => {
                create = create.split(from).join(to);
              });
              create = JSON.parse(create);

              return api.post('offers', create)
                .then((created: any) => {
                  replaceIds[data.id] = created.data.payload.id;
                });
            });
            await Promise.all(tasks);
          }

          selection = this.selected['trafficSources'];
          if (selection && selection.length) {
            tasks = selection.map((data: any) => api
              .post('traffic-sources', data)
              .then((created: any) => {
                replaceIds[data.id] = created.data.payload.id;
              })
            );
            await Promise.all(tasks);
          }

          selection = this.selected['flows'];
          if (selection && selection.length) {
            tasks = selection.map((data: any) => {

              let create = JSON.stringify(data);
              _.forOwn(replaceIds, (to, from) => {
                create = create.split(from).join(to);
              });
              create = JSON.parse(create);

              return api.post('flows', create)
                .then((created: any) => {
                  replaceIds[data.id] = created.data.payload.id;
                });
            });
            await Promise.all(tasks);
          }

          selection = this.selected['campaigns'];
          if (selection && selection.length) {
            tasks = selection.map((data: any) => {

              let create = JSON.stringify(data);
              _.forOwn(replaceIds, (to, from) => {
                create = create.split(from).join(to);
              });
              create = JSON.parse(create);

              return api.post('campaigns', create)
                .then((created: any) => {
                  replaceIds[data.id] = created.data.payload.id;
                });
            });
            await Promise.all(tasks);
          }
        } catch(e) {
          this.importing = false;
          this.bus.emit('toast-error', this.t('The Import Error occurred. Please contact Support Team for assistance.'));
          return;
        }

      this.importing = false;
      this.tab = 0;
      _.forEach(this.tabs, type => {
        this.items[type].map((e: any) => {
          e.selected = false;
        });
      });
      this.$forceUpdate();
      this.bus.emit('toast-success', this.t('Data imported successfully.'));
    }
}
